/* ============================================================
   TELEPORTATION — Floating gallery theme — behaviour
   ------------------------------------------------------------
   - Home gallery: CSS grid handles centering; JS only assigns
     the slow float animation to each item.
   - Product page: size selector -> variant, quantity picker
     (price = unit x qty), collapsible card on mobile,
     AJAX add-to-cart + fly/toast FX.
   - Cart page: AJAX quantity change / remove, live totals.
   ============================================================ */
(function () {
  'use strict';

  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  /* ---------- Money formatting (Shopify standard) ---------- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var fmt = format || '${{amount}}';
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;

    function withDelimiters(number, precision, thousands, decimal) {
      precision = isNaN(precision) ? 2 : precision;
      thousands = thousands || ',';
      decimal = decimal || '.';
      if (isNaN(number) || number == null) return '0';
      number = (number / 100).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var cents = parts[1] ? decimal + parts[1] : '';
      return dollars + cents;
    }

    var value = '';
    var match = fmt.match(placeholder);
    var token = match ? match[1] : 'amount';
    switch (token) {
      case 'amount': value = withDelimiters(cents, 2); break;
      case 'amount_no_decimals': value = withDelimiters(cents, 0); break;
      case 'amount_with_comma_separator': value = withDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = withDelimiters(cents, 0, '.', ','); break;
      case 'amount_with_space_separator': value = withDelimiters(cents, 2, ' ', '.'); break;
      case 'amount_no_decimals_with_space_separator': value = withDelimiters(cents, 0, ' ', ''); break;
      case 'amount_with_apostrophe_separator': value = withDelimiters(cents, 2, "'", '.'); break;
      default: value = withDelimiters(cents, 2);
    }
    return fmt.replace(placeholder, value);
  }

  /* ============================================================
     GALLERY
     ============================================================ */
  function layoutGallery() {
    var g = document.querySelector('[data-tp-gallery]');
    if (!g) return;
    var items = Array.prototype.slice.call(g.querySelectorAll('[data-tp-item]'));
    if (!items.length) return;

    items.forEach(function (it) {
      it.style.position = '';
      it.style.left = '';
      it.style.top = '';
      it.style.width = '';

      var fl = it.querySelector('.tp-float');
      if (fl) {
        fl.style.animation = '';
      }
    });

    g.style.height = '';
  }

  function initSmoothProductLinks() {
    var g = document.querySelector('[data-tp-gallery]');
    if (!g) return;
    g.addEventListener('click', function (e) {
      var link = e.target.closest('[data-tp-item]');
      if (!link) return;
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || link.target === '_blank') return;
      e.preventDefault();
      link.classList.add('is-leaving');
      document.body.classList.add('tp-page-leaving');
      setTimeout(function () {
        window.location.href = link.href;
      }, 520);
    });
  }

  /* ============================================================
     ADDED-TO-CART FX — fly dot + cart bump + toast "VIEW CART"
     ============================================================ */
  function ensureToast() {
    var t = document.querySelector('.tp-toast');
    if (t) return t;
    t = document.createElement('a');
    t.className = 'tp-toast';
    t.href = (window.routes && window.routes.cart_url) || (ROOT + 'cart');
    t.innerHTML =
      '<span class="tp-toast-check">✓</span>' +
      '<span class="tp-toast-text">ADDED TO CART</span>' +
      '<span class="tp-toast-cta">VIEW CART →</span>';
    document.body.appendChild(t);
    return t;
  }

  function cartAddedFx(fromEl) {
    var pill = document.querySelector('.tp-cart');

    if (fromEl && pill) {
      var a = fromEl.getBoundingClientRect();
      var b = pill.getBoundingClientRect();
      var dot = document.createElement('span');
      dot.className = 'tp-fly';
      dot.style.left = (a.left + a.width / 2) + 'px';
      dot.style.top = (a.top + a.height / 2) + 'px';
      document.body.appendChild(dot);
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          dot.style.transform =
            'translate(' + (b.left + b.width / 2 - (a.left + a.width / 2)) + 'px,' +
            (b.top + b.height / 2 - (a.top + a.height / 2)) + 'px) scale(.22)';
          dot.style.opacity = '0';
        });
      });
      setTimeout(function () { if (dot.parentNode) dot.parentNode.removeChild(dot); }, 850);

      setTimeout(function () {
        pill.classList.remove('is-bumping');
        void pill.offsetWidth;
        pill.classList.add('is-bumping');
      }, 560);
    }

    var t = ensureToast();
    clearTimeout(t._t);
    t.classList.remove('is-visible');
    void t.offsetWidth;
    t.classList.add('is-visible');
    t._t = setTimeout(function () { t.classList.remove('is-visible'); }, 4200);
  }

  /* ============================================================
     PRODUCT
     ============================================================ */
  function initProduct() {
    var root = document.querySelector('[data-tp-product-page]');
    if (!root) return;

    var form = document.querySelector('[data-tp-form]');
    var variantInput = document.querySelector('[data-tp-variant-id]');
    var sizeWrap = document.querySelector('[data-tp-sizes]');
    var sizeLabel = document.querySelector('[data-tp-size-label]');
    var priceEl = document.querySelector('[data-tp-price]');
    var atc = document.querySelector('[data-tp-atc]');
    var atcLabel = document.querySelector('[data-tp-atc-label]');
    var qtyInput = document.querySelector('[data-tp-qty-input]');

    /* ---- Carte repliable (mobile) ---- */
    var isMobile = window.matchMedia('(max-width: 767px)');
    document.querySelectorAll('[data-tp-card-toggle]').forEach(function (tg) {
      tg.addEventListener('click', function () {
        if (!isMobile.matches) return;
        var card = tg.closest('[data-tp-card]');
        if (card) card.classList.toggle('is-open');
      });
    });

    var variants = [];
    var moneyFormat = '${{amount}}';
    try {
      variants = JSON.parse(document.querySelector('[data-tp-variants]').textContent);
    } catch (e) {}
    try {
      moneyFormat = JSON.parse(document.querySelector('[data-tp-money-format]').textContent);
    } catch (e) {}

    var currentPrice = 0;
    (function initCurrentPrice() {
      var id = variantInput ? String(variantInput.value) : '';
      for (var i = 0; i < variants.length; i++) {
        if (String(variants[i].id) === id) { currentPrice = variants[i].price; return; }
      }
      if (variants.length) currentPrice = variants[0].price;
    })();

    function clampQty() {
      if (!qtyInput) return 1;
      var v = parseInt(qtyInput.value, 10);
      if (isNaN(v) || v < 1) v = 1;
      qtyInput.value = v;
      return v;
    }

    function updatePrice() {
      if (!priceEl || !currentPrice) return;
      priceEl.textContent = formatMoney(currentPrice * clampQty(), moneyFormat);
    }

    function variantForValue(val) {
      for (var i = 0; i < variants.length; i++) {
        if (String(variants[i].option1) === String(val)) return variants[i];
      }
      return null;
    }

    function selectSize(val) {
      var v = variantForValue(val);
      if (!v || !v.available) return;
      if (variantInput) variantInput.value = v.id;
      if (sizeLabel) sizeLabel.textContent = '[ ' + val + ' ]';
      currentPrice = v.price;
      updatePrice();
      if (sizeWrap) {
        sizeWrap.querySelectorAll('[data-tp-size]').forEach(function (b) {
          b.classList.toggle('is-active', b.getAttribute('data-tp-size') === String(val));
        });
      }
      if (atc) {
        atc.disabled = false;
        if (atcLabel) atcLabel.textContent = 'ADD TO CART';
      }
    }

    if (sizeWrap) {
      sizeWrap.addEventListener('click', function (e) {
        var b = e.target.closest('[data-tp-size]');
        if (!b || b.disabled) return;
        selectSize(b.getAttribute('data-tp-size'));
      });
    }

    document.querySelectorAll('[data-tp-qty-btn]').forEach(function (b) {
      b.addEventListener('click', function () {
        if (!qtyInput) return;
        var d = parseInt(b.getAttribute('data-tp-qty-btn'), 10) || 0;
        var v = clampQty() + d;
        if (v < 1) v = 1;
        qtyInput.value = v;
        updatePrice();
      });
    });
    if (qtyInput) {
      qtyInput.addEventListener('change', function () { clampQty(); updatePrice(); });
      qtyInput.addEventListener('input', function () {
        var v = parseInt(qtyInput.value, 10);
        if (!isNaN(v) && v >= 1) updatePrice();
      });
    }

    updatePrice();

    /* ---- Restriction par pays (Shopify Markets) ----
       window.TP_COUNTRY est injecté coté serveur par tp-floating-product.liquid
       via {{ localization.country.iso_code | json }}.
       Pour la France et l’Union européenne, XS et 2XL sont masqués sold-out
       visuellement, en reflet du stock réel déjà à 0 dans Shopify. */
    (function applyCountryRestrictions() {
      var country = (window.TP_COUNTRY || '').toUpperCase();
      var restrictedCountries = window.TP_RESTRICTED_COUNTRIES || [];
      var restrictedSizes = window.TP_RESTRICTED_SIZES || [];
      if (!country || restrictedCountries.indexOf(country) === -1) return;
      if (!sizeWrap || !restrictedSizes.length) return;

      /* Marquer les variantes comme indisponibles dans le tableau local
         pour que selectSize() les refuse si elles étaient pré-sélectionnées */
      for (var i = 0; i < variants.length; i++) {
        if (restrictedSizes.indexOf(String(variants[i].option1)) !== -1) {
          variants[i] = { id: variants[i].id, option1: variants[i].option1, available: false, price: variants[i].price };
        }
      }

      restrictedSizes.forEach(function (size) {
        sizeWrap.querySelectorAll('[data-tp-size]').forEach(function (btn) {
          if (btn.getAttribute('data-tp-size') !== size) return;
          btn.classList.add('is-sold');
          btn.disabled = true;
          btn.setAttribute('aria-disabled', 'true');
          /* Si cette taille était déjà active (pré-sélectionnée), on désélectionne */
          if (btn.classList.contains('is-active')) {
            btn.classList.remove('is-active');
            if (variantInput) variantInput.value = '';
            if (sizeLabel) sizeLabel.textContent = '[ — ]';
            if (atc) {
              atc.disabled = true;
              if (atcLabel) atcLabel.textContent = 'SELECT SIZE';
            }
          }
        });
      });
    })();

    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (atc && atc.disabled) return;
        clampQty();
        var data = new FormData(form);
        fetch(ROOT + 'cart/add.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json' },
          body: data
        })
          .then(function (r) { return r.json(); })
          .then(function (res) {
            if (res && res.status && res.status !== 200) {
              if (atcLabel) atcLabel.textContent = 'TRY AGAIN';
              return;
            }
            if (atcLabel) atcLabel.textContent = 'ADDED ✓';
            updateCartCount();
            cartAddedFx(atc);
            clearTimeout(form._t);
            form._t = setTimeout(function () {
              if (atcLabel) atcLabel.textContent = 'ADD TO CART';
            }, 2200);
          })
          .catch(function () {
            if (atcLabel) atcLabel.textContent = 'TRY AGAIN';
          });
      });
    }

    var secs = Array.prototype.slice.call(document.querySelectorAll('[data-tp-sec]'));
    var thumbs = Array.prototype.slice.call(document.querySelectorAll('[data-tp-thumb]'));
    var dots = Array.prototype.slice.call(document.querySelectorAll('[data-tp-dot]'));

    function scrollToSec(i) {
      var el = document.getElementById('tp-sec-' + i);
      if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { scrollToSec(+t.getAttribute('data-tp-thumb')); });
    });
    dots.forEach(function (d) {
      d.addEventListener('click', function () { scrollToSec(+d.getAttribute('data-tp-dot')); });
    });

    var active = -1;
    function onScroll() {
      if (!secs.length) return;
      var mid = window.scrollY + window.innerHeight / 2;
      var idx = 0;
      secs.forEach(function (s, i) { if (s.offsetTop <= mid) idx = i; });
      if (idx === active) return;
      active = idx;
      thumbs.forEach(function (t, i) { t.classList.toggle('is-active', i === idx); });
      dots.forEach(function (d, i) { d.classList.toggle('is-active', i === idx); });
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ============================================================
     CART PAGE — AJAX line updates
     ============================================================ */
  function initCart() {
    var page = document.querySelector('[data-tp-cart-page]');
    if (!page) return;

    var moneyFormat = '${{amount}}';
    try {
      moneyFormat = JSON.parse(page.querySelector('[data-tp-money-format]').textContent);
    } catch (e) {}

    var busy = false;

    function change(line, qty) {
      if (busy) return;
      busy = true;
      page.classList.add('is-updating');
      fetch(ROOT + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ line: line, quantity: qty })
      })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          if (qty === 0 || cart.item_count === 0) {
            window.location.reload();
            return;
          }
          var row = page.querySelector('[data-tp-line="' + line + '"]');
          var item = cart.items[line - 1];
          if (row && item) {
            var qv = row.querySelector('[data-tp-cqty-val]');
            var lp = row.querySelector('[data-tp-line-price]');
            if (qv) qv.textContent = item.quantity;
            if (lp) lp.textContent = formatMoney(item.final_line_price, moneyFormat);
          }
          var sub = page.querySelector('[data-tp-cart-subtotal]');
          if (sub) sub.textContent = formatMoney(cart.total_price, moneyFormat);
          var cl = page.querySelector('[data-tp-cart-count-label]');
          if (cl) cl.textContent = cart.item_count + (cart.item_count === 1 ? ' ITEM' : ' ITEMS');
          var cc = document.querySelector('[data-tp-cart-count]');
          if (cc) cc.textContent = cart.item_count;
          busy = false;
          page.classList.remove('is-updating');
        })
        .catch(function () {
          busy = false;
          page.classList.remove('is-updating');
        });
    }

    page.addEventListener('click', function (e) {
      var qbtn = e.target.closest('[data-tp-cqty]');
      if (qbtn) {
        var row = qbtn.closest('[data-tp-line]');
        if (!row) return;
        var line = parseInt(row.getAttribute('data-tp-line'), 10);
        var cur = parseInt(row.querySelector('[data-tp-cqty-val]').textContent, 10) || 1;
        var next = cur + (parseInt(qbtn.getAttribute('data-tp-cqty'), 10) || 0);
        if (next < 0) next = 0;
        change(line, next);
        return;
      }
      var rbtn = e.target.closest('[data-tp-remove]');
      if (rbtn) {
        var rrow = rbtn.closest('[data-tp-line]');
        if (!rrow) return;
        change(parseInt(rrow.getAttribute('data-tp-line'), 10), 0);
      }
    });
  }

  /* ---------- Shared: live cart count ---------- */
  function updateCartCount() {
    var el = document.querySelector('[data-tp-cart-count]');
    if (!el) return;
    fetch(ROOT + 'cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { el.textContent = c.item_count; })
      .catch(function () {});
  }

  /* ---------- Boot ---------- */
  function boot() {
    layoutGallery();
    initSmoothProductLinks();
    initProduct();
    initCart();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  var rt;
  window.addEventListener('resize', function () {
    clearTimeout(rt);
    rt = setTimeout(layoutGallery, 150);
  }, { passive: true });

  window.addEventListener('load', layoutGallery);

  /* Retour arrière (bfcache) — efface l'état leaving pour eviter page blanche */
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) {
      document.body.classList.remove('tp-page-leaving');
      document.querySelectorAll('.is-leaving').forEach(function (el) {
        el.classList.remove('is-leaving');
      });
    }
  });
})();
